export default "__VITE_ASSET__f8fa658c__"